import React, { Component } from "react"
import Config from '../Config'
import axios from 'axios';
import { render } from '@testing-library/react';
import { NotificationManager } from 'react-notifications';
import TinyMCE from 'react-tinymce';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import ReactTimeAgo from 'react-time-ago'
import JavascriptTimeAgo from 'javascript-time-ago'
import FileBase64 from 'react-file-base64';
import moment from 'moment'
import logos from '../layout/pageheader.jpeg'



import en from 'javascript-time-ago/locale/en'
JavascriptTimeAgo.locale(en)
export default class CreateTicket extends Component {
    constructor (props) {
        super(props)

        this.config = new Config()
        this.$http = this.config.DConnect()
        this.state = {
            reportData: [], smShow: false, isEdit: this.props.isEdit,
            formItems: { id: 0, usercomment: "", ticketid: "", user: '', lastreply: '' }
            , ticketid: '', ticketData: {}, comments: [], category: [], users: [], message: '',

            uploadedFiles: [], files: [], media: [], department: [],

            mainpost: [], userpost: [], adminpost: []
        }
    }


    componentDidMount() {
        const { match: { params } } = this.props
        let ticketid = params.ticketid
        this.getTicket(ticketid)
        this.getDeparment()
        this.getCategory()
        //setInterval(this.getTicket(ticketid), 5000);
        this.setState({ ticketid })



    }

    callMe = () => {
        setTimeout(() => {
            const { match: { params } } = this.props
            let ticketid = params.ticketid
            this.getTicket(ticketid)
            this.getDeparment()
            this.getCategory()
            //setInterval(this.getTicket(ticketid), 5000);
            this.setState({ ticketid })
        }, 1000)
    }

    componentDidUpdate(nextProps) {
        if (nextProps.ticketid !== this.props.ticketid) {
            const { match: { params } } = nextProps
            let ticketid = params.ticketid
            this.getTicket(ticketid)
            this.getCategory()
            this.setState({ ticketid })
        }

    }

    getFiles = (e) => {
        let files = e.target.files
        this.setState({ files })
    }

    handleEditorChange = (e) => {
        let message = this.state.message
        message = e.target.value
        this.setState({ message })
    }

    getTicket = (id) => {

        this.$http.get('ticket/getTicket/' + id)
            .then(res => {
                let ticketData = res.data
                if (ticketData == null) {
                    this.props.history.push('/');
                    window.location.reload(true)
                }
                this.setState({ ticketData })
            })
        this.getMedia(id)
        this.getReplys(id)

    }
    getReplys = (id) => {
        this.$http.get('replys/getComment/' + id)
            .then(res => {
                let comments = res.data
                this.setState({ comments })
            })
    }
    getCategory = () => {
        this.$http.get('category/fetchAll')
            .then(res => {
                let category = res.data
                this.setState({ category })
            })
    }
    categoryFormat = (id) => {
        let name = this.state.category.filter(itm => itm.id == id)
        let cname = (name != '') ? name[0].cat_title : ''
        return cname
    }
    getLastreplier = (id) => {
        this.$http.get('replys/lastreplier/' + id)
            .then(res => {
                let lastreplier = res.data
                lastreplier = (lastreplier == null) ? { lastreply: "" } : lastreplier

                this.setState({ lastreplier })
            })
    }

    getUser = () => {
        this.$http.get('users/fetchAll')
            .then(res => {
                let users = res.data
                this.setState({ users })
            })
    }

    nameFomart = (cell) => {
        let result
        let name = this.state.users.filter(itm => itm.username == cell)
        if (name != '') {
            result = name[0].name
        } else {
            result = cell
        }
        return (
            <span > <i>{result}</i></span>
        )
    }

    getMedia = (id) => {
        this.$http.get('media/fetchmedia/' + id)
            .then(res => {
                let media = res.data
                let adminpost = media.filter(itm => itm.comment == 1)
                let userpost = media.filter(itm => itm.comment == 2)
                let mainpost = media.filter(itm => itm.comment == 0)
                this.setState({ mainpost, userpost, adminpost, media })
            })
    }

    imageFormats = (id) => {
        let mainpost = this.state.media.filter(itm => itm.msgid == id)
        let post = []
        if (mainpost != '') {
            post = mainpost
        }

        return (
            <span>
                {
                    post.map(itm =>
                        <a href={this.config.Downloadlink() + itm.attachments} target="_blank">{itm.attachments}</a>

                    )
                }
            </span>
        )
    }
    imageFormatsStaff = (id) => {
        let adminpost = this.state.media.filter(itm => itm.comment == 1 && itm.msgid == id)
        let post = []
        if (adminpost != '') {
            post = adminpost
        }

        return (
            <span>
                {
                    post.map(itm =>
                        <a href={this.config.Downloadlink() + itm.attachments} target="_blank">{itm.attachments}</a>

                    )
                }
            </span>
        )
    }

    imageFormatsUser = (id) => {
        let userpost = this.state.media.filter(itm => parseInt(itm.comment) == 2 && itm.msgid == id)
        let post = []
        if (userpost != '') {
            post = userpost
        }
        return (
            <span>
                {
                    post.map(itm =>
                        <a href={this.config.Downloadlink() + itm.attachments} target="_blank">{itm.attachments}</a>

                    )
                }
            </span>
        )
    }

    updateon() {
        let formData = { ticketid: this.state.ticketid, updateon: moment(new Date()).format('YYYY/MM/DD h:m:s') }
        axios(this.config.PostOptions(formData, 'ticket/updates'))
            .then(res => {
                let respond = res.data
                // if(respond.status==1){
                //     NotificationManager.success(respond.message, 'Successful!', 4000);
                // }else{
                //     NotificationManager.error(respond.message, 'Error!', 4000);
                // }

            })
    }

    getDeparment = () => {
        this.$http.get('dropdowns/getDropdownfieldname/department')
            .then(res => {
                let department = res.data
                this.setState({ department });
            })
    }
    submit = (e) => {
        e.preventDefault()
        let fitm = this.state.formItems
        fitm['usercomment'] = this.state.message
        fitm['user'] = this.state.ticketData.name
        fitm['ticketid'] = this.state.ticketid
        fitm['lastreply'] = this.state.ticketData.name

        let files = this.state.files
        if (fitm['usercomment'] == '') {
            NotificationManager.error("Please type a message...", 'Error!', 4000);
            return
        }
        let msgid
        if (files.length > 0) {
            msgid = Math.floor((Math.random() * 910000100010) + 1)
        } else {
            msgid = ''
        }
        fitm['msgid'] = msgid
        if (fitm.comment != '') {
            axios(this.config.PostOptions(fitm, 'replys/createuserreply'))
                .then(res => {
                    let respond = res.data
                    if (respond.status == 1) {
                        NotificationManager.success(respond.message, 'Successful!', 6000);
                        let form = { id: 0, usercomment: "", ticketid: "", user: '', lastreply: '' }
                        this.setState({ form })
                        this.componentDidMount()
                        this.updateon()
                        this.getReplys(this.state.ticketid)
                        this.SendEmail('reply', this.state.ticketid)
                        this.setState({message:""})

                    } else {
                        NotificationManager.error(respond.message, 'Error!', 4000);
                    }
                })

            if (files.length > 0) {

                this.LoadMedia(fitm['ticketid'], msgid)
            } else {
                // this.props.history.push('/chatpage/' + fitm['ticketid']);
                // window.location.reload(true)
            }
        }
    }

    LoadMedia = (code, imgCode) => {
        let imgfile = this.state.files[0]
        // alert(JSON.stringify(imgfile))
        const fd = new FormData();
        fd.append('pimage', imgfile);
        axios.post(`${this.config.BaseURLImage()}uploadfiles.php?ticketid=${code + imgCode}`, fd).then(res => {
            let resdata = res.data
            //alert(JSON.stringify(resdata))
            this.createImage(resdata, code, imgCode)


        })//.catch(function (error) { alert(error); });
    }

    createImage = (res, code, msgid) => {
        let formData = { filename: res.name }
        axios(this.config.PostOptions(formData, 'media/createusermedia/' + code + "/" + res.name + "/" + msgid))
            .then(res => {
                let respond = res.data

                if (respond.status == 1) {
                    NotificationManager.success(respond.message, 'Successful!', 6000);
                    this.setState({ formItems: { message: '' } })
                    this.componentDidMount()
                   
                } else {
                    this.props.history.push('/chatpage/' + code);
                    window.location.reload(true)
                   // NotificationManager.error(respond.message, 'Error!', 4000);
                }
            })
    }

    departmentFormat = (id) => {
        let depa = this.state.department.filter(itm => itm.ivalue == id)
        let name = (depa != '') ? depa[0].iname : id
        return name
    }
    SendEmail = (area, ticketid) => {
        this.$http.get('sendmail/sendemail/' + area + '/' + ticketid)
            .then(res => {
                let email = res.data
                //this.setState({ mainpost,userpost,adminpost })
            })
    }

    render() {


        return (

            <div>

                <div class="hero-section bg_img style-two" data-background={logos}>
                    <div class="container">
                        <div class="cate-header cl-white">
                            <h5 >{this.state.ticketData.subject}</h5>
                            <br></br>
                            <p>{this.state.ticketid}</p>
                            <div class="cate-meta">
                                <div class="left">
                                    <span>{this.state.ticketData.createdon} By</span>
                                    <div class="thumb">
                                        <a href="#0"><span className="fa fa-user" /></a>
                                    </div>
                                    <h6 class="subtitle"><a href="#0">{this.state.ticketData.name}</a></h6>

                                </div>

                                <div class="right">
                                    <i class="flaticon-view-files"></i><span>{this.categoryFormat(this.state.ticketData.category)}</span>

                                </div>
                                Attachment:{this.imageFormats(this.state.ticketData.ticketid)}
                            </div>
                        </div>
                    </div>
                </div>

                <section class="category-section padding-bottom mt--160 pos-rel">
                    <div class="container">
                        <div class="category-single-wrapper">
                            <div class="single-item">
                                {/* <h2 class="title">{this.state.ticketData.subject}</h2> */}
                                <p>{this.state.ticketData.message}</p>
                            </div>
                            {/* <div class="single-item">
                                <div class="row row-broken body-panel text-left">
                                    <div class="col-sm-12 col-xs-12 " tabindex="5001">
                                        {this.state.comments.map(itm =>
                                            <div>
                                                {(itm.admincomment !== null) &&
                                                    <div class="panel panel-success" >
                                                        <div class="panel-heading">{this.nameFomart(itm.staff)}</div>
                                                        <div class="panel-body">{itm.admincomment}</div>
                                                        <div class="panel-footer"><ReactTimeAgo date={itm.times} />


                                                            <span>
                                                                &nbsp;  Attachment:&nbsp; {this.imageFormatsStaff(itm.msgid)}
                                                            </span>
                                                        </div>
                                                        <br></br>
                                                    </div>
                                                }
                                                {(itm.usercomment !== null) &&
                                                    <div class="panel panel-warning" style={{background:"yellow"}}>
                                                        <div class="panel-heading">{this.nameFomart(itm.user)}</div>
                                                        <div class="panel-body">{itm.usercomment}</div>
                                                        <div class="panel-footer"><ReactTimeAgo date={itm.times} />


                                                            <span>
                                                                &nbsp;  Attachment:&nbsp;{this.imageFormatsUser(itm.msgid)}
                                                            </span>

                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        )}

                                    </div>


                                </div>
                                <div class="panel-footer clearfix">
                                    <textarea id="subject" name="message" value={this.state.message} onChange={this.handleEditorChange} required placeholder="Write something.."
                                        style={{ height: "200px" }}></textarea>
                                    <div class="form-group ">
                                        <FileBase64 multiple={true} onDone={this.getFiles} />

                                    </div>
                                    <span class="col-lg-4  col-md-4  col-xs-4 pull-right" style={{ marginTop: "10px" }}>
                                        <button class="btn btn-warning btn-lg btn-block" onClick={this.submit} id="btn-chat">Send</button>
                                    </span>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <br></br>
                    <div class="container">

                        <div class="row mb-30-none justify-content-center">
                            {this.state.comments.map(itm =>
                                <div class="col-12">
                                    {(itm.admincomment !== null) &&
                                        <div class="cate-single-item">
                                            {/* <h4 class="title">Can I pay for my Deskoto account via PayPal?</h4> */}
                                            <p>{itm.admincomment}</p>
                                            <div class="cate-author">
                                                {/* <div class="thumb">
                                                    <a href="#0"><span className="fa fa-user" /></a>
                                                </div> */}
                                                <div class="content">
                                                    <h5 class="subtitle"><a href="#0">{this.nameFomart(itm.staff)}</a></h5>
                                                    <span>&nbsp;  Attachment:&nbsp; {this.imageFormatsStaff(itm.msgid)} &nbsp; Time: <ReactTimeAgo date={itm.times} /></span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {(itm.usercomment !== null) &&
                                        <div class="cate-single-item" style={{ background: "#F8F7F7" }}>
                                            {/* <h4 class="title">How do I upgrade my Deskoto account to a better plan?</h4> */}
                                            <p>{itm.usercomment}</p>
                                            <div class="cate-author">
                                                {/* <div class="thumb">
                                                    <a href="#0"><img src="./assets/images/cate/01.png" alt="cate" /></a>
                                                </div> */}
                                                <div class="content">
                                                    <h5 class="subtitle"><a href="#0">{this.nameFomart(itm.user)}</a></h5>
                                                    <span>Attachment:&nbsp;{this.imageFormatsUser(itm.msgid)} &nbsp; Time: <ReactTimeAgo date={itm.times} /></span>
                                                </div>
                                            </div>
                                        </div>}

                                </div>
                            )}


                        </div>
                    </div>

                    <br></br>
                    <div class="container">

                        <div class="row mb-30-none justify-content-center">

                            <div class="col-12">

                                <div class="cate-single-item">
                                    <div class="panel-footer clearfix">
                                        <textarea id="subject" name="message" value={this.state.message} onChange={this.handleEditorChange} required placeholder="Write something.."
                                            style={{ height: "200px" }}></textarea>

                                        <div class="form-group ">
                                            <input type="file" name="pimage" className="form-control" onChange={this.getFiles} />
                                            {/* <FileBase64 multiple={true} onDone={this.getFiles} /> */}

                                        </div>
                                        <span class="col-lg-4  col-md-4  col-xs-4 pull-right" style={{ marginTop: "10px" }}>
                                            <button class="btn btn-warning btn-lg btn-block" onClick={this.submit} id="btn-chat">Send</button>
                                        </span>
                                    </div>
                                </div>


                            </div>



                        </div>
                    </div>
                </section>



                {/* <div class="article-overview section tint">
                    <div class="container w-container">
                        <div class="knowledge-base-row w-row">
                            <div class="knowledge-base-column-left w-col w-col-12">
                                <div>
                                    <div class="knowledge-base-block">
                                        <div class="overall-dynamic-list-wrapper w-dyn-list">
                                            <div class="panel panel-primary">
                                                <div class="panel-heading"><p style={{ textAlign: "justify" }}> Department :<b>{this.departmentFormat(this.state.ticketData.companyName)}</b> Subject: <b>{this.state.ticketData.subject}</b></p></div>
                                                <div class="panel-body">{this.state.ticketData.message}

                                                </div>
                                                <div class="panel-footer">Createdby:<b>{this.state.ticketData.name}</b> Createdon:<b>{this.state.ticketData.createdon}</b> Category:<b>{this.categoryFormat(this.state.ticketData.category)}</b>
                                                    <span>
                                                        &nbsp;  Attachment:&nbsp; {this.imageFormats(this.state.ticketData.ticketid)}
                                                    </span>
                                                </div>
                                            </div>
                                            <div style={{ width: "100%", height: "1px", backgroundColor: "black" }} />
                                            <div class="row row-broken body-panel text-left">
                                                <div class="col-sm-12 col-xs-12 " tabindex="5001">
                                                    {this.state.comments.map(itm =>



                                                        <div>
                                                            {(itm.admincomment !== null) &&
                                                                <div class="panel panel-success" >
                                                                    <div class="panel-heading">{this.nameFomart(itm.staff)}</div>
                                                                    <div class="panel-body">{itm.admincomment}</div>
                                                                    <div class="panel-footer"><ReactTimeAgo date={itm.times} />


                                                                        <span>
                                                                            &nbsp;  Attachment:&nbsp; {this.imageFormatsStaff(itm.msgid)}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {(itm.usercomment !== null) &&
                                                                <div class="panel panel-warning">
                                                                    <div class="panel-heading">{this.nameFomart(itm.user)}</div>
                                                                    <div class="panel-body">{itm.usercomment}</div>
                                                                    <div class="panel-footer"><ReactTimeAgo date={itm.times} />


                                                                        <span>
                                                                            &nbsp;  Attachment:&nbsp;{this.imageFormatsUser(itm.msgid)}
                                                                        </span>

                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>


                                                        // }
                                                    )}

                                                </div>
                                            </div>
                                            <br></br>

                                           
                                            <br></br>
                                            <div class="panel-footer clearfix">
                                                <textarea id="subject" name="message" value={this.state.message} onChange={this.handleEditorChange} required placeholder="Write something.."
                                                    style={{ height: "200px" }}></textarea>
                                                
                                                <div class="form-group ">
                                                    <FileBase64 multiple={true} onDone={this.getFiles} />

                                                </div>
                                                <span class="col-lg-4  col-md-4  col-xs-4 pull-right" style={{ marginTop: "10px" }}>
                                                    <button class="btn btn-warning btn-lg btn-block" onClick={this.submit} id="btn-chat">Send</button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                </div> */}
            </div>



        )
    }
}
